import React from 'react'
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';

import Container from '../../layout/container'
import { StepStyle, StepGroup, StepItem } from './style'

import Img1 from '../../assets/step/step1.svg'
import Img2 from '../../assets/step/step2.svg'
import Img3 from '../../assets/step/step3.svg'
import Img4 from '../../assets/step/step4.svg'

const items = [
  {
    id: 1,
    title: 'Regístrate',
    text: 'Completa tus datos. Recuerda que debes ser mayor de 18 años.',
    img: Img1
  },
  {
    id: 2,
    title: 'Te contactamos',
    text: 'En un tiempo estimado de 24 horas recibirás nuestra llamada.',
    img: Img2
  },
  {
    id: 3,
    title: 'Kit de inicio',
    text: 'Compra tu kit de inicio para dar el primer paso de tu negocio.',
    img: Img3
  },
  {
    id: 4,
    title: 'Bonificación',
    text: 'Premiamos tu compromiso. ¡Nos encanta verte crecer!',
    img: Img4
  }
]

export default function Step() {
  return (
    <StepStyle id="comofunciona">
      <h2>¿Cómo emprender con OBoticário?</h2>

      <Container>
        <StepGroup>
          {items.map(({ id, title, text, img }) =>
            <Item
              key={id}
              id={id}
              title={title}
              text={text}
              img={img}
            />
          )}
        </StepGroup>
        
        <Carousel dots lazyload infinite className="StepGroupMobile">
          {items.map(({ id, title, text, img }) =>
            <Item
              key={id}
              id={id}
              title={title}
              text={text}
              img={img}
            />
          )}
        </Carousel>
      </Container>
    </StepStyle>
  )
}

const Item = ({ id, title, text, img }) => {
  return (
    <StepItem>
      <h3>paso <span>{id}</span></h3>
      <img src={img} alt={title} loading="lazy" />
      <h4>{title}</h4>
      <p>{text}</p>
    </StepItem>
  )
}